import React from 'react';
import { Tabs } from 'antd';
import ImpactSettingComponent from './Impacteng';


export default function ImpactSetting() {

    const { TabPane } = Tabs;
    function callback(key) {
        //   console.log(key);
    }
    return (
        <div>
            <Tabs defaultActiveKey="1" onChange={callback} size="large" centered>

                <TabPane tab="Impact Page Setting" key="1">
                    <ImpactSettingComponent/>
                </TabPane>

            </Tabs>
        </div>
    )
}
